export enum Colors {
  BLACK = '#333333',
  GRAY = '#757575',
  WHITE = '#ffffff',
  CAPRI_BLUE = '#1D5883',
  WINDOW_GRAY = '#9A9FA3',
  LIGHT_GRAY = '#EEEEEE',
  ERROR = '#FF6565',
  MONO_PHASE = '#1684DD',
  THREE_PHASE = '#DE373D',
  SOURCE_AVAILABLE = '#57D9A3',
  IN_USE = '#1684DD',
  PURPLE = '#5B21B6',
  BLUE = '#1E40AF',
  RED = '#DC2626',

  // --- Extended palette (tinted towards the brand blue) ---
  /** Pressed / hover shade of the brand blue. */
  CAPRI_BLUE_DARK = '#174769',
  /** Very light brand tint for selected rows, chips and info panels. */
  CAPRI_BLUE_TINT = '#EAF1F7',
  /** Deep navy used for the postpaid wallet card and dark panels. */
  NAVY = '#123A57',
  /** Readable secondary text (>= 4.5:1 on white). */
  TEXT_SECONDARY = '#5F6B76',
  /** Ink for headings on tinted surfaces. */
  INK = '#1F2A33',
  /** Page-level soft surface (footer, skeleton base, chart panels). */
  SURFACE = '#F4F7FA',
  /** Slightly stronger surface for segmented controls and list hover. */
  SURFACE_MUTED = '#E9EEF3',
  /** Hairlines and card borders. */
  BORDER = '#DFE6EC',
  /** Input borders at rest. */
  BORDER_STRONG = '#C5CFD8',
  /** Readable green for "paid" / "available" text. */
  SUCCESS = '#1B8F63',
  SUCCESS_TINT = '#E6F7EF',
  /** Readable red for error text. */
  ERROR_DARK = '#C93D3D',
  ERROR_TINT = '#FDECEC',
  PURPLE_TINT = '#F1EBFB',
  MONO_PHASE_TINT = '#E8F3FC',
  THREE_PHASE_TINT = '#FCEBEC',
}
